import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import useGetTarget from 'Domain/target/useGetTarget';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { tableText } from 'Const/target/text';

import TableSkeleton from 'View/target/component/tableSkeleton';
import { useTargetState } from 'View/target/state';

import { getTableList } from './const';
import styles from './styles.module.css';

const Table = ({ t }) => {
  const accessPermission = getMenuPermissions('master-data', 'target');
  const tableList = getTableList({ t });
  const { updateState, filterState, updateFilterState } = useTargetState();

  const { data, isFetching } = useGetTarget(filterState);

  const onChangePagination = (page) => updateFilterState({ page });
  const onChangeSort = (sort) => updateFilterState({ sort });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableSkeleton />}>
        <TableComponent
          isCanCreate={accessPermission?.isCanCreate}
          columns={tableList}
          dataSource={data?.targets || []}
          sortingData={filterState?.sort}
          onSort={onChangeSort}
          tableName="table__target"
          isScrollable={true}
          isDataExist={data?.isDataExist}
          emptyActionText={tableText.actionText}
          onEmptyStateAction={() => updateState({ isOpenFormUpsert: true })}
          paddingBodyBox="0px"
          verticalAlignBody="baseline"
          rowHeight="fit-content"
          maxTableHeight="calc(100vh - 305px)"
          maxTableBodyHeight="calc(100vh - 385px)"
          tableComponentHeight="calc(100vh - 249px)"
          pagination={{
            currentPage: filterState?.page,
            totalData: data?.totalData,
            onChange: onChangePagination,
            isLoading: isFetching,
          }}
        />
      </Condition>
    </Box>
  );
};

export default Table;
